import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, MapPinIcon, SendIcon } from 'lucide-react';
export function KontaktPage() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setFormState({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      setIsSubmitted(false);
    }, 4000);
  };
  return <section className="py-16 md:py-24 bg-white" data-id="element-442">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-443">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-vita-green-deep mb-4" data-id="element-444">
          Kontakt
        </h1>
        <p className="text-lg text-vita-text-muted mb-12 leading-relaxed" data-id="element-445">
          Hast du eine Frage oder möchtest du uns etwas mitteilen? Wir freuen
          uns, von dir zu hören.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-446">
          {/* Contact Form */}
          <div className="md:col-span-2" data-id="element-447">
            {isSubmitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="bg-vita-green-pale rounded-softer p-8 text-center border border-vita-green-light" data-id="element-448">
                <div className="w-14 h-14 rounded-full bg-vita-green-light flex items-center justify-center mx-auto mb-4" data-id="element-449">
                  <SendIcon className="w-6 h-6 text-vita-green-deep" data-id="element-450" />
                </div>
                <h3 className="font-heading text-xl font-bold text-vita-green-deep mb-2" data-id="element-451">
                  Nachricht gesendet!
                </h3>
                <p className="text-vita-text-muted" data-id="element-452">
                  Vielen Dank für deine Nachricht. Wir melden uns so schnell wie
                  möglich bei dir.
                </p>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-453">
                <div data-id="element-454">
                  <label htmlFor="name" className="block text-sm font-medium text-vita-text mb-1.5" data-id="element-455">
                    Name
                  </label>
                  <input id="name" type="text" required value={formState.name} onChange={e => setFormState(s => ({
                ...s,
                name: e.target.value
              }))} className="w-full px-4 py-3 rounded-soft border border-vita-border bg-vita-cream/30 focus:outline-none focus:ring-2 focus:ring-vita-green-sage focus:border-transparent transition-shadow text-vita-text" placeholder="Dein Name" data-id="element-456" />
                </div>

                <div data-id="element-457">
                  <label htmlFor="email" className="block text-sm font-medium text-vita-text mb-1.5" data-id="element-458">
                    E-Mail
                  </label>
                  <input id="email" type="email" required value={formState.email} onChange={e => setFormState(s => ({
                ...s,
                email: e.target.value
              }))} className="w-full px-4 py-3 rounded-soft border border-vita-border bg-vita-cream/30 focus:outline-none focus:ring-2 focus:ring-vita-green-sage focus:border-transparent transition-shadow text-vita-text" placeholder="deine@email.de" data-id="element-459" />
                </div>

                <div data-id="element-460">
                  <label htmlFor="subject" className="block text-sm font-medium text-vita-text mb-1.5" data-id="element-461">
                    Betreff
                  </label>
                  <input id="subject" type="text" required value={formState.subject} onChange={e => setFormState(s => ({
                ...s,
                subject: e.target.value
              }))} className="w-full px-4 py-3 rounded-soft border border-vita-border bg-vita-cream/30 focus:outline-none focus:ring-2 focus:ring-vita-green-sage focus:border-transparent transition-shadow text-vita-text" placeholder="Worum geht es?" data-id="element-462" />
                </div>

                <div data-id="element-463">
                  <label htmlFor="message" className="block text-sm font-medium text-vita-text mb-1.5" data-id="element-464">
                    Nachricht
                  </label>
                  <textarea id="message" required rows={5} value={formState.message} onChange={e => setFormState(s => ({
                ...s,
                message: e.target.value
              }))} className="w-full px-4 py-3 rounded-soft border border-vita-border bg-vita-cream/30 focus:outline-none focus:ring-2 focus:ring-vita-green-sage focus:border-transparent transition-shadow text-vita-text resize-none" placeholder="Deine Nachricht..." data-id="element-465" />
                </div>

                <button type="submit" className="inline-flex items-center px-8 py-3.5 bg-vita-green-deep text-white font-medium rounded-full hover:bg-vita-green-medium transition-colors" data-id="element-466">
                  <SendIcon className="w-4 h-4 mr-2" data-id="element-467" />
                  Nachricht senden
                </button>
              </form>}
          </div>

          {/* Contact Info Sidebar */}
          <div className="space-y-6" data-id="element-468">
            <div className="bg-vita-cream rounded-softer p-6 border border-vita-border" data-id="element-469">
              <div className="flex items-center gap-3 mb-3" data-id="element-470">
                <div className="w-10 h-10 rounded-full bg-vita-green-light flex items-center justify-center" data-id="element-471">
                  <MailIcon className="w-5 h-5 text-vita-green-deep" data-id="element-472" />
                </div>
                <h3 className="font-medium text-vita-text" data-id="element-473">E-Mail</h3>
              </div>
              <p className="text-vita-text-muted text-sm" data-id="element-474">info@vitafrukt.de</p>
            </div>

            <div className="bg-vita-cream rounded-softer p-6 border border-vita-border" data-id="element-475">
              <div className="flex items-center gap-3 mb-3" data-id="element-476">
                <div className="w-10 h-10 rounded-full bg-vita-green-light flex items-center justify-center" data-id="element-477">
                  <MapPinIcon className="w-5 h-5 text-vita-green-deep" data-id="element-478" />
                </div>
                <h3 className="font-medium text-vita-text" data-id="element-479">Standort</h3>
              </div>
              <p className="text-vita-text-muted text-sm" data-id="element-480">
                Berlin, Deutschland
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}